import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsResourcesBlocks } from "../../../data/SubjectContent/maths/resources";

export function PageMathsResources() {
    return (
        <CoursePageLayout
            title="數學科 | 網上學習資源"
            subtitle="ONLINE LEARNING RESOURCES"
            menuData={mathMenuData}
            nowIndex={5}
            topImage={{ src: mathsImg.resourcesTop, imgHeight: "600px" }}
            blocks={mathsResourcesBlocks}
        />
    );
}
